@if (!(isLocationEnabled$ | async) || ((isLocationEnabled$ | async) && !(isPermissionGranted$ | async))) {
  <div
    (click)="openLocationFlow()"
    [class.location-banner]="isPageLoaded$ | async"
    [class.or-d-flex]="isPageLoaded$ | async"
    [class.or-align-items-center]="isPageLoaded$ | async"
    [class.or-justify-content-center]="isPageLoaded$ | async"
    [class.border-radius-8]="isPageLoaded$ | async"
    [class.or-py-8-px]="isPageLoaded$ | async"
    [class.or-px-12-px]="isPageLoaded$ | async">
    @if (!(isLocationEnabled$ | async) && (isPageLoaded$ | async)) {
      <span>Kliknij aby włączyć lokalizację</span>
    }
    @if ((isLocationEnabled$ | async) && !(isPermissionGranted$ | async) && (isPageLoaded$ | async)) {
      <span>Kliknij aby nadać uprawnienia lokalizacji</span>
    }
  </div>
}
